export default __webpack_public_path__ + "static/media/3.93bbe86f.png";